import React from 'react';
import PropTypes from 'prop-types';

import { Criterium, CriteriumSkeleton } from '@hydra/common/criterium';
import { Translate } from '@hydra/common/components';
import { useReviewContext } from '@hydra/common/context';

const getContent = ({ value, valid }) => {
  if (valid) {
    return value;
  }
  if (value) {
    return <Translate content='doctype_invalid' with={{ doctype: value }} />;
  }
  return <Translate content='missing' />;
};

export const Doctype = ({ criterium }) => {
  const { data } = criterium;
  const { variant } = useReviewContext();

  if (typeof data === 'string') {
    const content = variant === 'nocrit' ? <CriteriumSkeleton width='20%' /> : <span>{data}</span>;
    return <Criterium criterium={criterium}>{content}</Criterium>;
  }

  const content = variant === 'nocrit' ? <CriteriumSkeleton width='20%' /> : <span>{getContent(data)}</span>;
  return <Criterium criterium={criterium}>{content}</Criterium>;
};

Doctype.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      valid: PropTypes.bool,
      value: PropTypes.string
    })
  })
};

export default React.memo(Doctype);
